import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

interface iProps {
  to: string;
  icon: React.ReactNode;
  children: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  color: inherit;
  font-family: 'Segoe UI', sans-serif; 
  font-size: 23px; 
  color:rgb(255, 255, 255); 

  &:hover {
    text-decoration: underline;
  }
`;

export const PounctMenu: React.FC<iProps> = ({ to, icon, children }) => {
  return (
    <li>
      <StyledLink to={to}>
        <>
        <span aria-hidden="true" role="img">
          {icon}
        </span>
        {children}
        </>
      </StyledLink>
    </li>
  );
};